import { Layout } from 'react-admin';

import { NavigateMenu } from 'admin/menu/navigate-menu';

export const MainLayout: React.FC<React.PropsWithChildren<{}>> = props => <Layout {...props} menu={NavigateMenu} />;